import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, withStyles} from "@material-ui/core";
import t from "../../../../../languages/pl";
import {buttonStyle} from "../buttonGroupStyle";
import SmsTable from './SmsTable';
import SmsModeButton from "./SmsModeButton";
import SmsInformationDialog from '../../../../Common/SmsInformationDialog';

const useStyles = theme => ({
    button: buttonStyle(theme),
    buttons: {
        display: "flex",
        justifyContent: "center"
    },
    textAlert: {
        padding: '24px',
        color: 'red',
        fontSize: '18px',
    }
});

const Sms = props => {
    const {
        classes,
        name,
        data,
        gpsState,
        onDialogOpen,
        onModeChange
    } = props;
    const [open, setOpen] = useState(false);
    const [infoDialogOpen, setInfoDialogOpen] = useState(false);
    const [smsData, setSmsData] = useState(null);
    const isDisabledService = Boolean(data.blokada_serwis);
    const isDisabledBlocked = Boolean(data.blokada_blokady);

    useEffect(() => {
        let intervalId = setInterval(() => {
            onDialogOpen();
        }, 60 * 1000);
        return (() => {
            clearInterval(intervalId);
        });
    }, []);

    const handleDialogOpen = () => {
        setOpen(true);
        onDialogOpen && onDialogOpen();
    };

    const sendAction = (mode, state) => {
        onModeChange(mode, state);
    };

    const handleClick = async (mode, newState) => {
        if (gpsState === "Rozłączony+" || gpsState === "Rozłączony") {
            await setSmsData({
                mode: mode,
                newState: newState
            });
            setInfoDialogOpen(true);
        } else {
            sendAction(mode, newState);
        }
    };

    const handleCloseInfoDialog = () => {
        sendAction(smsData.mode, smsData.newState);
        setSmsData(null);
        setInfoDialogOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.sms}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="md"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.sendingMessageToCar}&nbsp;{name}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.container}>
                        <div className={classes.buttons}>
                            <SmsModeButton
                                name="service"
                                background={isDisabledService ? null : "#346517"}
                                value={data.serwis}
                                onLabel={t.turnOnServiceMode}
                                offLabel={t.turnOffServiceMode}
                                gpsState={gpsState} actionText={t.serviceMode.toLowerCase()}
                                tooltipTitle={t.serviceModeDescription}
                                isDisabled={isDisabledService}
                                onClick={(newState) => handleClick("serwis", newState)}
                            />

                            <SmsModeButton
                                name="blocked"
                                background={isDisabledBlocked ? null : "#BB502E"}
                                value={data.blokada}
                                onLabel={t.turnOnBlockMode}
                                offLabel={t.turnOffBlockMode}
                                gpsState={gpsState} actionText={t.blockedMode.toLowerCase()}
                                tooltipTitle={t.blockedModeDescription}
                                isDisabled={isDisabledBlocked}
                                onClick={(newState) => handleClick("blokada", newState)}
                            />
                        </div>

                        <SmsTable smsList={data.lista_sms}/>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setOpen(false)}
                    >
                        {t.close}
                    </Button>
                </DialogActions>
            </Dialog>
            <SmsInformationDialog
                open={infoDialogOpen}
                onClose={handleCloseInfoDialog}
                title={t.info}
            />
        </React.Fragment>
    );
};

export default withStyles(useStyles)(Sms);

Sms.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    data: PropTypes.object,
    gpsState: PropTypes.string,
    onDialogOpen: PropTypes.func,
    onModeChange: PropTypes.func,
};
